export enum DepotDisplayEnum {
    Overview = 1,
    Audit = 2
}